import script from "./SensorsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensorsView.vue?vue&type=script&setup=true&lang=ts"

import "./SensorsView.vue?vue&type=style&index=0&id=4c349812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c349812"]])

export default __exports__